import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const journalfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {
    const formFields = [
        {
            label: 'Date',
            key: 'date',
            type: 'date',
            placeholder: 'Enter the date',
            visible: true,
            width: '25%',
        },
        {
            label: 'Transaction Type',
            key: 'transaction_type',
            type: 'text',
            placeholder: 'Enter the transaction type',
            visible: true,
            width: '25%',
        },
        {
            label: 'Transaction ID',
            key: 'transaction_id',
            type: 'text',
            placeholder: 'Enter the transaction ID',
            visible: true,
            width: '25%',
        },
        {
            label: 'Transaction Number',
            key: 'transaction_number',
            type: 'text',
            placeholder: 'Enter the transaction number',
            visible: true,
            width: '25%',
        },
        {
            label: 'Reference Number',
            key: 'reference_number',
            type: 'text',
            placeholder: 'Enter the reference number',
            visible: true,
            width: '25%',
        },
        {
            label: 'Narration',
            key: 'narration',
            type: 'text',
            placeholder: 'Enter the narration',
            visible: true,
            width: '25%',
        },
        {
            label: 'Line Item Total',
            key: 'line_item_total',
            type: 'number',
            placeholder: 'Enter the line item total',
            visible: true,
            width: '25%',
        },
    ];

    const CustomFields = response.CustomFields;

    if (CustomFields && CustomFields.length > 0) {
        CustomFields.forEach((field) => {
            formFields.push({
                label: field.name,
                key: 'cf.' + field.key,
                type: field.type,
                placeholder: field.placeholder,
                visible: true,
                width: '25%',
                viewField: true,
            });
        });
    }

    return formFields;
}

export const journalMobileCard = (item, index, getFieldValue) => {
    return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View>
            <Text>TEST</Text>
            <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
        </View>
    </Card>;
}

export const journalMain = {
    fields: journalfields,
    mobileCard: null
}


